import {
    ChevronLeftIcon,
    ChevronRightIcon,
} from "@heroicons/react/24/outline";

const Pagination = ({ page, onPreviousPage, onNextPage }) => (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
        <div className="flex flex-1 justify-between sm:hidden">
            <div className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-50">
                Previous
            </div>
            <div className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-slate-50">
                Next
            </div>
        </div>
        <div className="hidden sm:flex sm:flex-1 px-2 sm:items-center sm:justify-between">
            <div>
                {/* <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{page}</span> to{" "}
                    <span className="font-medium">10</span> of{" "}
                    <span className="font-medium">97</span> results
                </p> */}
            </div>
            <div>
                <nav
                    aria-label="Pagination"
                    className="isolate inline-flex p-4"
                >
                    <div
                        onClick={onPreviousPage}
                        className="relative inline-flex items-center rounded-l-full px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-slate-50 focus:z-20 focus:outline-offset-0"
                    >
                        <span className="sr-only">Previous</span>
                        <ChevronLeftIcon
                            aria-hidden="true"
                            className="h-5 w-5"
                        />
                    </div>

                    <div
                        onClick={onNextPage}
                        className="relative inline-flex items-center rounded-r-full px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-slate-50 focus:z-20 focus:outline-offset-0"
                    >
                        <span className="sr-only">Next</span>
                        <ChevronRightIcon
                            aria-hidden="true"
                            className="h-5 w-5"
                        />
                    </div>
                </nav>
            </div>
        </div>
    </div>
);

export default Pagination;
